import Vue from 'vue'
import VueApollo from 'vue-apollo';
import { createApolloClient } from 'vue-cli-plugin-apollo/graphql-client';

// Install the vue plugin
Vue.use(VueApollo)

// Config
const defaultOptions = {
    // You can use `https` for secure connection (recommended in production)
    // httpEndpoint: process.env.VUE_APP_GRAPHQL_HTTP || 'http://localhost:4000/graphql',
    // You can use `wss` for secure connection (recommended in production)
    // Use `null` to disable subscriptions
    wsEndpoint: null, //process.env.VUE_APP_GRAPHQL_WS || 'ws://localhost:4000/graphql',
    // LocalStorage token
    // tokenName: 'apollo-token',
    // Enable Automatic Query persisting with Apollo Engine
    persisting: false,
    // Use websockets for everything (no HTTP)
    // You need to pass a `wsEndpoint` for this to work
    websocketsOnly: false,
    // Is being rendered on the server?
    ssr: false,
    // Override the way the Authorization header is set
    getAuth: () => undefined, //using cookies
    // Additional ApolloClient options
    apollo: {
      queryDeduplication: true,
      name: 'portal-transparencia-ui',
      version: '1.0',
      // defaultOptions = {
      //   watchQuery: {
      //     fetchPolicy: 'cache-and-network',
      //     errorPolicy: 'ignore',
      //   },
      //   query: {
      //     fetchPolicy: 'network-only',
      //     errorPolicy: 'all',
      //   },
      //   mutate: {
      //     errorPolicy: 'all'
      //   }
      // }    
    },
  
    // Client local data (see apollo-link-state)
    // clientState: { resolvers: { ... }, defaults: { ... } }
  
    // Override default apollo link
    // If you want to replace the default HttpLink, set `defaultHttpLink` to false
    // note: don't override httpLink here, specify httpLink options in the
    // httpLinkOptions property of defaultOptions.
    // link: myLink
    // If true, add the default HttpLink.
    // Disable it if you want to replace it with a terminating link using `link` option.
    // defaultHttpLink: false
    // Options for the default HttpLink
    httpLinkOptions: {
      credentials: 'include'
    },
  
    // Override default cache (apollo-cache-inmemory)
    // cache: myCache
    // Options for the default cache
    inMemoryCacheOptions: {
      
    },
}

// Call this in the Vue app file
export function createApolloProvider() {
  // Create apollo client
  const createPortal = createApolloClient({
    ...defaultOptions,
    httpEndpoint: '/api',
  });
  const createPortalv2 = createApolloClient({
    ...defaultOptions,
    httpEndpoint: '/api/v2',
  });
  // Create vue apollo provider
  const apolloProvider = new VueApollo({
    defaultClient: createPortal.apolloClient,
    clients: {
      v1: createPortal.apolloClient,
      v2: createPortalv2.apolloClient
    },
    errorHandler(error) {
      // eslint-disable-next-line no-console
      console.log('%cError', 'background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;', error.message);
    },
  });
  return apolloProvider;
}
